/** Dummy rooms + guest hub requests for the staff board (no API yet). */

const minutesAgo = (mins) => new Date(Date.now() - mins * 60 * 1000).toISOString();

export const DUMMY_ROOMS = [
  {
    id: "room-401",
    tableNumber: "401",
    type: "room",
    location: "Floor 4 · Ocean Wing",
    capacity: 2,
    isActive: true,
    guestName: "A. Pereira",
    checkIn: "Sep 8",
    checkOut: "Sep 12",
    doNotDisturb: false,
    makeupRequested: true,
  },
  {
    id: "room-402",
    tableNumber: "402",
    type: "room",
    location: "Floor 4 · Ocean Wing",
    capacity: 2,
    isActive: true,
    guestName: "M. Silva",
    checkIn: "Sep 9",
    checkOut: "Sep 11",
    doNotDisturb: true,
    makeupRequested: false,
  },
  {
    id: "room-405",
    tableNumber: "405",
    type: "room",
    location: "Floor 4 · Garden Wing",
    capacity: 3,
    isActive: true,
    guestName: "J. Fernando",
    checkIn: "Sep 7",
    checkOut: "Sep 14",
    doNotDisturb: false,
    makeupRequested: false,
  },
  {
    id: "room-412",
    tableNumber: "412",
    type: "room",
    location: "Floor 4 · Garden Wing",
    capacity: 2,
    isActive: true,
    guestName: "S. Wijesinghe",
    checkIn: "Sep 10",
    checkOut: "Sep 13",
    doNotDisturb: false,
    makeupRequested: false,
  },
  {
    id: "room-501",
    tableNumber: "501",
    type: "room",
    location: "Floor 5 · Suite",
    capacity: 4,
    isActive: true,
    guestName: "R. Jayawardena",
    checkIn: "Sep 6",
    checkOut: "Sep 15",
    doNotDisturb: false,
    makeupRequested: false,
  },
  {
    id: "room-508",
    tableNumber: "508",
    type: "room",
    location: "Floor 5 · Ocean Wing",
    capacity: 2,
    isActive: true,
    guestName: null,
    checkIn: null,
    checkOut: null,
    doNotDisturb: false,
    makeupRequested: false,
  },
  {
    id: "room-602",
    tableNumber: "602",
    type: "room",
    location: "Floor 6 · Penthouse",
    capacity: 4,
    isActive: true,
    guestName: "L. Gunasekara",
    checkIn: "Sep 9",
    checkOut: "Sep 12",
    doNotDisturb: true,
    makeupRequested: false,
  },
  {
    id: "room-610",
    tableNumber: "610",
    type: "room",
    location: "Floor 6 · Ocean Wing",
    capacity: 2,
    isActive: true,
    guestName: "N. Bandara",
    checkIn: "Sep 10",
    checkOut: "Sep 11",
    doNotDisturb: false,
    makeupRequested: true,
  },
];

export const DUMMY_REQUESTS = [
  {
    id: "req-1",
    companyId: "demo",
    tableId: "room-412",
    locationLabel: "Room 412",
    type: "housekeeping",
    catalogItemId: "towels",
    title: "Extra towels",
    details: "Please bring 4 bath towels",
    etaMinutes: 20,
    status: "requested",
    createdAt: minutesAgo(8),
  },
  {
    id: "req-2",
    companyId: "demo",
    tableId: "room-401",
    locationLabel: "Room 401",
    type: "makeup-room",
    title: "Make up room",
    details: "Guest requested room service cleaning",
    etaMinutes: 45,
    status: "acknowledged",
    active: true,
    createdAt: minutesAgo(25),
  },
  {
    id: "req-3",
    companyId: "demo",
    tableId: "room-405",
    locationLabel: "Room 405",
    type: "maintenance",
    catalogItemId: "ac",
    title: "AC not cooling",
    details: "Unit blows warm air since morning",
    etaMinutes: 60,
    status: "in_progress",
    createdAt: minutesAgo(55),
  },
  {
    id: "req-4",
    companyId: "demo",
    tableId: "room-501",
    locationLabel: "Room 501",
    type: "room-service",
    title: "Room service order",
    details: "Club sandwich ×2, fresh orange juice ×2",
    etaMinutes: 35,
    status: "requested",
    orderNo: "RS-1042",
    createdAt: minutesAgo(4),
  },
  {
    id: "req-5",
    companyId: "demo",
    tableId: "room-610",
    locationLabel: "Room 610",
    type: "laundry",
    catalogItemId: "express",
    title: "Express laundry",
    details: "2 shirts, 1 trousers — needed by 6 PM",
    etaMinutes: 180,
    status: "acknowledged",
    createdAt: minutesAgo(90),
  },
  {
    id: "req-6",
    companyId: "demo",
    tableId: "room-402",
    locationLabel: "Room 402",
    type: "dnd",
    title: "Do not disturb",
    details: "Guest enabled DND",
    status: "requested",
    active: true,
    createdAt: minutesAgo(120),
  },
  {
    id: "req-7",
    companyId: "demo",
    tableId: "room-501",
    locationLabel: "Room 501",
    type: "concierge",
    catalogItemId: "taxi",
    title: "Airport taxi",
    details: "Pickup at 10:30 AM tomorrow, 2 guests + luggage",
    etaMinutes: null,
    status: "requested",
    createdAt: minutesAgo(15),
  },
  {
    id: "req-8",
    companyId: "demo",
    tableId: "room-412",
    locationLabel: "Room 412",
    type: "amenities",
    catalogItemId: "toiletries",
    title: "Toiletries refill",
    details: "Shampoo and body lotion",
    etaMinutes: 15,
    status: "completed",
    createdAt: minutesAgo(200),
    updatedAt: minutesAgo(160),
  },
  {
    id: "req-9",
    companyId: "demo",
    tableId: "room-602",
    locationLabel: "Room 602",
    type: "help",
    title: "Front desk help",
    details: "Question about late checkout options",
    status: "in_progress",
    createdAt: minutesAgo(12),
  },
  {
    id: "req-10",
    companyId: "demo",
    tableId: "room-405",
    locationLabel: "Room 405",
    type: "housekeeping",
    catalogItemId: "pillows",
    title: "Extra pillows",
    details: "2 soft pillows please",
    etaMinutes: 20,
    status: "requested",
    createdAt: minutesAgo(2),
  },
];

export const REQUEST_TYPE_META = {
  housekeeping: { label: "Housekeeping", color: "#0d9488", icon: "cleaning" },
  laundry: { label: "Laundry", color: "#0284c7", icon: "laundry" },
  maintenance: { label: "Maintenance", color: "#ea580c", icon: "build" },
  amenities: { label: "Amenities", color: "#7c3aed", icon: "spa" },
  concierge: { label: "Concierge", color: "#be185d", icon: "concierge" },
  help: { label: "Help", color: "#475569", icon: "help" },
  dnd: { label: "Do not disturb", color: "#b91c1c", icon: "dnd" },
  "makeup-room": { label: "Make up room", color: "#ca8a04", icon: "bed" },
  "room-service": { label: "Room service", color: "#c2410c", icon: "food" },
  food: { label: "Food", color: "#c2410c", icon: "food" },
  events: { label: "Events", color: "#4f46e5", icon: "event" },
};

export const STATUS_META = {
  requested: { label: "New", color: "#dc2626", next: "acknowledged" },
  acknowledged: { label: "Acknowledged", color: "#d97706", next: "in_progress" },
  in_progress: { label: "In progress", color: "#2563eb", next: "completed" },
  completed: { label: "Completed", color: "#16a34a", next: null },
  cancelled: { label: "Cancelled", color: "#64748b", next: null },
};
